import { ref } from 'vue';

// IPアドレスを取得する関数
export async function fetchIpAddress() {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data.ip; // IPアドレスを返す
  } catch (error) {
    console.error('Error fetching IP address:', error);
    return null; // エラー時にはnullを返す
  }
}

// OS情報とバージョンを取得する関数
export function getOSInfo() {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform || 'unknown';
  let os = 'unknown';
  let version = 'unknown';
  // OS情報とバージョンの判定
  // Windows
  if (/Windows NT/.test(userAgent)) {
    os = 'Windows';
    const versionMap = {
      '10.0': '10',
      '6.3': '8.1',
      '6.2': '8',
      '6.1': '7',
      '6.0': 'Vista',
      '5.1': 'XP',
      '5.0': '2000',
    };
    const matched = /Windows NT ([0-9.]+)/.exec(userAgent);
    if (matched && versionMap[matched[1]]) {
      version = versionMap[matched[1]];
    }
  }
  // macOS
  else if (/Mac OS X/.test(userAgent) && !/iPhone|iPad|iPod/.test(userAgent)) {
    os = 'macOS';
    const matched = /Mac OS X ([0-9._]+)/.exec(userAgent);
    if (matched) {
      version = matched[1].replace(/_/g, '.');
    }
  }
  // iOS
  else if (/iPhone|iPad|iPod/.test(userAgent)) {
    os = 'iOS';
    const matched = /OS (\d+_\d+)/.exec(userAgent);
    if (matched) {
      version = matched[1].replace(/_/g, '.');
    }
  }
  // Android
  else if (/Android/.test(userAgent)) {
    os = 'Android';
    const matched = /Android ([0-9.]+)/.exec(userAgent);
    if (matched) {
      version = matched[1];
    }
  }
  // Linux
  else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return { os, version };
}

// ブラウザ情報とバージョンを取得する関数
export function getBrowserInfo() {
  const userAgent = navigator.userAgent;

  let browserName = 'unknown';
  let browserVersion = 'unknown';

  // ブラウザ情報とバージョンの判定
  if (/chrome|crios|crmo/i.test(userAgent)) {
    browserName = 'Chrome';
    browserVersion = userAgent.match(/(?:chrome|crios|crmo)\/([0-9.]+)/i)[1];
  } else if (/firefox|fxios/i.test(userAgent)) {
    browserName = 'Firefox';
    browserVersion = userAgent.match(/(?:firefox|fxios)\/([0-9.]+)/i)[1];
  } else if (/safari/i.test(userAgent) && !/chrome|crios|crmo/i.test(userAgent)) {
    browserName = 'Safari';
    browserVersion = userAgent.match(/version\/([0-9.]+)/i)[1];
  } else if (/msie|trident/i.test(userAgent)) {
    browserName = 'Internet Explorer';
    const match = userAgent.match(/(?:msie |rv:)([0-9.]+)/i);
    if (match) {
      browserVersion = match[1];
    }
  } else if (/edg/i.test(userAgent)) {
    browserName = 'Edge';
    browserVersion = userAgent.match(/edg\/([0-9.]+)/i)[1];
  }

  return { browserName, browserVersion };
}

// OS・ブラウザ情報を返す関数
export async function getDeviceInfo() {
  const isUAData = !!(navigator.userAgentData && navigator.userAgentData.getHighEntropyValues);
  const userAgent = navigator.userAgent;

  // Android + userAgentData対応
  if (isUAData && /Android/i.test(userAgent)) {
    let os = "Android";
    let osVer = "unknown";
    let browser = "unknown";
    let browserVer = "unknown";
    try {
      const uaData = await navigator.userAgentData.getHighEntropyValues([
        "platform", "platformVersion", "fullVersionList"
      ]);
      os = uaData.platform || "Android";
      osVer = uaData.platformVersion || "unknown";
      if (uaData.fullVersionList && Array.isArray(uaData.fullVersionList)) {
        // ダミーデータを排除
        const realBrands = uaData.fullVersionList.filter(
          b => !/^Not.*Brand$/.test(b.brand)
        );
        // 1つの文字列にまとめる
        browser = realBrands.map(b => b.brand).join(', ');
        browserVer = realBrands.map(b => b.version).join(', ');
      }
    } catch (e) {
      // 何もしない
    }

    return { os, osVer, browser, browserVer };
  }

  // Android端末だがuserAgentData未対応の場合はunknownで返す
  if (/Android/i.test(userAgent)) {
    return {
      os: "Android",
      osVer: "unknown",
      browser: "unknown",
      browserVer: "unknown"
    };
  }

  // それ以外は従来のuserAgentパース
  const osInfo = getOSInfo();
  const browserInfo = getBrowserInfo();
  return {
    os: osInfo.os,
    osVer: osInfo.version,
    browser: browserInfo.browserName,
    browserVer: browserInfo.browserVersion
  };
}

// ログデータを初期化する関数
export async function initializeLogData(store) {
  const logData = ref({
    userId: store.getters.userId,
    companyCode: store.getters.companyCode,
    companyName: store.getters.companyName,
    ipAddress: '',
    os: '',
    osVer: '',
    browser: '',
    browserVer: ''
  });

  // IPアドレスをlogDataに格納する
  logData.value.ipAddress = await fetchIpAddress();

   // OS・ブラウザ情報
   const deviceInfo = await getDeviceInfo();
   logData.value.os = deviceInfo.os;
   logData.value.osVer = deviceInfo.osVer;
   logData.value.browser = deviceInfo.browser;
   logData.value.browserVer = deviceInfo.browserVer;

  console.log('Log Data:', logData.value); // logDataの内容を確認

  return logData;
}
